import { render, staticRenderFns } from "./LeadTrengoOrigin.vue?vue&type=template&id=70fab9e1&scoped=true&"
import script from "./LeadTrengoOrigin.vue?vue&type=script&lang=js&"
export * from "./LeadTrengoOrigin.vue?vue&type=script&lang=js&"
import style0 from "./LeadTrengoOrigin.vue?vue&type=style&index=0&id=70fab9e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fab9e1",
  null
  
)

export default component.exports